import {RouteDefinition} from "../../../routes"
import {BootLogsScreen} from "./BootLogs"
import {CallLogsScreen} from "./CallListLogs"
import {LogScreen} from "./LogScreen"
import {UserLogs} from "./UserLogs"

export const LogsRoutes: RouteDefinition[] = [
    {
        routerLink: "/settings/logs",
        component: LogScreen
    },
    {
        routerLink: "/settings/logs/user-logs",
        component: UserLogs
    },
    {
        routerLink: "/settings/logs/call-logs",
        component: CallLogsScreen
    },
    {
        routerLink: "/settings/logs/boot-logs",
        component: BootLogsScreen,
    }
]
